import * as React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";

import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { colors, radius } from "../../theme/modern";

const NumberButton = props => (
  <TouchableOpacity
    activeOpacity={0.6}
    disabled={props.text === ""}
    style={[styles.key, props.text === "" ? styles.keyEmpty : null]}
    onPress={() => props.onNumberPress(props.text)}
  >
    <Text style={styles.keyText}>{props.text}</Text>
  </TouchableOpacity>
);

const DeleteButton = props => (
  <TouchableOpacity
    activeOpacity={0.6}
    style={styles.key}
    onPress={() => props.onDeletePress()}
  >
    <Icon name="backspace" size={22} color={colors.danger} />
  </TouchableOpacity>
);

export default class ModalKeypadComponent extends React.PureComponent {
  render() {
    return (
      <View>
        <View style={styles.modalView}>
          <NumberButton text="1" onNumberPress={this.props.onNumberPress} />
          <NumberButton text="2" onNumberPress={this.props.onNumberPress} />
          <NumberButton text="3" onNumberPress={this.props.onNumberPress} />
        </View>
        <View style={styles.modalView}>
          <NumberButton text="4" onNumberPress={this.props.onNumberPress} />
          <NumberButton text="5" onNumberPress={this.props.onNumberPress} />
          <NumberButton text="6" onNumberPress={this.props.onNumberPress} />
        </View>
        <View style={styles.modalView}>
          <NumberButton text="7" onNumberPress={this.props.onNumberPress} />
          <NumberButton text="8" onNumberPress={this.props.onNumberPress} />
          <NumberButton text="9" onNumberPress={this.props.onNumberPress} />
        </View>
        <View style={styles.modalView}>
          {"noPeriod" in this.props ? (
            <NumberButton text="" onNumberPress={test => null} />
          ) : (
            <NumberButton text="." onNumberPress={this.props.onNumberPress} />
          )}
          <NumberButton text="0" onNumberPress={this.props.onNumberPress} />
          <DeleteButton onDeletePress={this.props.onDeletePress} />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  key: {
    width: 76,
    height: 52,
    margin: 4,
    borderRadius: radius.medium,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f1f5f9",
  },
  keyEmpty: {
    backgroundColor: "transparent",
  },
  keyText: {
    fontSize: 20,
    fontWeight: "600",
    color: colors.text,
  },
  modalView: {
    flexDirection: "row",
  },
});
